// eslint-disable-next-line import/prefer-default-export
export enum SupplierInfoActionStatus {
  AUTO_UPDATED = "Auto Updated",
  CREATING = "Creating",
  CREATED = "Created",
  RELINKED = "Relinked",
  RELINKING = "Relinking",
  SKIPPED = "Skipped",
}
